import React from 'react'

function CourseManageTutor() {
  return (
    <div>
      WELCOM TUTOR
    </div>
  )
}

export default CourseManageTutor
